var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const fetchOptions = {
    mode: 'cors',
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
    },
};
export function getCurrentUser() {
    return __awaiter(this, arguments, void 0, function* (ignoreErrors = false) {
        const response = yield fetch('/api/user/current', Object.assign(Object.assign({}, fetchOptions), { redirect: 'manual' }));
        if (response.status === 200) {
            return yield response.json();
        }
        if (!ignoreErrors) {
            yield handleApiError(response, 'Current user');
        }
    });
}
export function getSyncStatus(syncType) {
    return __awaiter(this, void 0, void 0, function* () {
        let searchParams = { type: syncType };
        const response = yield fetch('/api/user/sync-status?' + new URLSearchParams(searchParams), Object.assign(Object.assign({}, fetchOptions), { redirect: 'manual' }));
        if (response.status === 200) {
            return yield response.json();
        }
        return null;
    });
}
export function getDashboard(yearMonth) {
    return __awaiter(this, void 0, void 0, function* () {
        let searchParams = {};
        if (yearMonth) {
            searchParams.yearMonth = yearMonth;
        }
        const orgResponse = yield fetch('/api/dashboard?' + new URLSearchParams(searchParams), fetchOptions);
        if (orgResponse.status === 200) {
            return yield orgResponse.json();
        }
        yield handleApiError(orgResponse, 'Dashboard');
    });
}
export function getOrganisations() {
    return __awaiter(this, void 0, void 0, function* () {
        const orgResponse = yield fetch('/api/organisation', fetchOptions);
        if (orgResponse.status === 200) {
            return yield orgResponse.json();
        }
        yield handleApiError(orgResponse, 'Organisations');
    });
}
export function updateOrganisations(orgId, request) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/organisation/${orgId}`, request);
    });
}
export function updateOrganisationContact(orgId, contactEmail) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/organisation/${orgId}/contact`, {
            email: contactEmail,
        });
    });
}
export function tagOrganisation(orgId, tag) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/organisation/${orgId}/tag/${tag}`);
    });
}
export function untagOrganisation(orgId, tag) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callDeleteApiJson(`/api/organisation/${orgId}/tag/${tag}`);
    });
}
export function updateOrganisationManager(orgId, managerId) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/organisation/${orgId}/manager`, {
            id: managerId,
        });
    });
}
export function getEmailsLog() {
    return __awaiter(this, void 0, void 0, function* () {
        return callGetApiJson('/api/emails/log');
    });
}
export function getEmailTemplate() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch('/api/emails/template', Object.assign(Object.assign({}, fetchOptions), { method: 'GET' }));
        if (response.status === 200) {
            return yield response.json();
        }
        else if (response.status === 404) {
            return undefined;
        }
        return Promise.reject(`/api/emails/template' api returned status ${response.status}`);
    });
}
export function createEmailTemplate(body) {
    return __awaiter(this, void 0, void 0, function* () {
        return callPostApiJson('/api/emails/template', body);
    });
}
export function updateEmailTemplate(body) {
    return __awaiter(this, void 0, void 0, function* () {
        return callPostApiJson(`/api/emails/template/${body.id}`, body);
    });
}
export function deleteEmailTemplate(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return callDeleteApi(`/api/emails/template/${id}`);
    });
}
export function removeXeroConnection(orgId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`/api/organisation/${orgId}`, { method: 'DELETE' });
        return response.ok;
    });
}
export function updateDashboardEntries(dashboardIds, status) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/dashboard`, {
            dashboardIds: dashboardIds,
            status: status,
        });
    });
}
export function setDashboardNote(dashboardId, note) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/dashboard/${dashboardId}/note`, {
            note,
        });
    });
}
export function dismissSyncStatus(syncStatusId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`/api/user/sync-status/${syncStatusId}/dismiss`, Object.assign(Object.assign({}, fetchOptions), { method: 'POST' }));
        if (response.ok) {
            return true;
        }
        return Promise.reject(`dismissSyncStatus failed with status ${response.status}`);
    });
}
export function syncDashboardEntries(dashboardIds) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/dashboard/sync`, dashboardIds);
    });
}
export function sendDashboardEmails(dashboardIds, subjectTemplate, contentTemplate, attachTransactions) {
    return __awaiter(this, void 0, void 0, function* () {
        const jsonResponse = yield callPostApiJson(`/api/dashboard/emails`, {
            dashboardIds,
            subjectTemplate,
            contentTemplate,
            attachTransactions,
        });
        return new Map(Object.entries(jsonResponse.results));
    });
}
export function previewReminderEmails(dashboardIds) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/dashboard/emails-preview`, { dashboardIds });
    });
}
export function syncTenants(orgIds) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/organisation/sync`, orgIds);
    });
}
export function getContacts(orgId) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callGetApiJson(`/api/organisation/${orgId}/contacts`);
    });
}
export function getOrgUsers(orgId) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callGetApiJson(`/api/organisation/${orgId}/users`);
    });
}
export function getFirmUsers(firmId) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callGetApiJson(`/api/firm/${firmId}/users`);
    });
}
export function getFirmPendingInvites(firmId) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callGetApiJson(`/api/firm/${firmId}/users/pending`);
    });
}
export function inviteUserToFirm(firmId, email) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`/api/firm/${firmId}/users`, Object.assign(Object.assign({}, fetchOptions), { method: 'POST', body: JSON.stringify({ email }) }));
        if (response.status === 200) {
            return yield response.json();
        }
        return Promise.reject(`inviteUserToFirm returned status ${response.status}`);
    });
}
export function updateFirm(firmId, name) {
    return __awaiter(this, void 0, void 0, function* () {
        return callPostApiJson(`/api/firm/${firmId}`, { name });
    });
}
export function updateFirmAccess(firmId, enabled) {
    return __awaiter(this, void 0, void 0, function* () {
        return callPostApiJson(`/api/firm/${firmId}/open-access`, { enabled });
    });
}
export function removeUserFromFirm(firmId, userId) {
    return __awaiter(this, void 0, void 0, function* () {
        return callDeleteApi(`/api/firm/${firmId}/user/${userId}`);
    });
}
export function sendSupportMessage(message, captchaValue, emailFrom) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`/api/support/contact`, Object.assign(Object.assign({}, fetchOptions), { method: 'POST', body: JSON.stringify({
                message,
                captchaValue,
                emailFrom,
            }) }));
        if (response.ok) {
            return true;
        }
        return Promise.reject(`sendSupportMessage returned status ${response.status}`);
    });
}
export function createPortalSession() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callPostApiJson(`/api/subscription/portal-session`);
    });
}
export function runSyncDashboardsJob(yearMonth) {
    return __awaiter(this, void 0, void 0, function* () {
        const syncResponse = yield fetch(`/api/manage/syncAllDashboards?yearMonth=${yearMonth}`, Object.assign(Object.assign({}, fetchOptions), { method: 'POST' }));
        return syncResponse.status;
    });
}
export function getAllUsers() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callGetApiJson(`/api/manage/users`);
    });
}
export function getAllInactiveUsers() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callGetApiJson(`/api/manage/inactive-users`);
    });
}
export function getStats() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callGetApiJson(`/api/manage/stats`);
    });
}
export function runSyncOrgJob() {
    return __awaiter(this, void 0, void 0, function* () {
        const syncResponse = yield fetch(`/api/manage/syncAllOrgs`, Object.assign(Object.assign({}, fetchOptions), { method: 'POST' }));
        return syncResponse.status;
    });
}
export function isXpmConnected(checkAuth) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield callGetApiJson(`/api/xpm/connected?checkAuth=` + checkAuth);
    });
}
function handleApiError(response, apiName) {
    return __awaiter(this, void 0, void 0, function* () {
        const statusCode = response.status;
        if (statusCode === 302 || statusCode === 401 || statusCode === 403 || (statusCode === 0 && response.type === 'opaqueredirect')) {
            window.location.href = '/login';
            return;
        }
        if (statusCode === 402) {
            window.location.href = '/subscription';
            return;
        }
        console.error(`error ${statusCode} ${JSON.stringify(response)} on ${apiName} `, yield response.text());
        if (statusCode === 500 || statusCode === 400) {
            window.location.href = `/error?status=${statusCode}&message=Issue while loading ${apiName}`;
            return;
        }
        // I think since we handle opaque redirect above we can all show some error in this use case
        // to be tested more.
        window.location.href = '/login';
        return;
    });
}
function callGetApiJson(path) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(path, Object.assign(Object.assign({}, fetchOptions), { method: 'GET' }));
        if (response.status === 200) {
            return yield response.json();
        }
        return Promise.reject(`${path} api returned status ${response.status}`);
    });
}
function callPostApiJson(path, body) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(path, Object.assign(Object.assign({}, fetchOptions), { method: 'POST', body: body && JSON.stringify(body) }));
        if (response.status === 200) {
            return yield response.json();
        }
        return Promise.reject(`${path} api returned status ${response.status}`);
    });
}
function callDeleteApi(path, body, hasResponseBody) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(path, Object.assign(Object.assign({}, fetchOptions), { method: 'DELETE', body: body && JSON.stringify(body) }));
        if (hasResponseBody) {
            if (response.status === 200) {
                return yield response.json();
            }
        }
        else {
            if (response.ok) {
                return true;
            }
        }
        return Promise.reject(`DELETE ${path} api returned status ${response.status}`);
    });
}
function callDeleteApiJson(path, body) {
    return __awaiter(this, void 0, void 0, function* () {
        return callDeleteApi(path, body, true);
    });
}
